export const TOGGLE_IS_PRODUCT_IMPORTER = 'TOGGLE_IS_PRODUCT_IMPORTER';

export function toggleIsProductImporter(isProductImporter){
    return{
        type: TOGGLE_IS_PRODUCT_IMPORTER,
        mainState: {
            isProductImporter: isProductImporter
        }
    }
}